import { render } from "./SobreView.vue?vue&type=template&id=6d2bed1a&scoped=true"
import script from "./SobreView.vue?vue&type=script&lang=js"
export * from "./SobreView.vue?vue&type=script&lang=js"

import "./SobreView.vue?vue&type=style&index=0&id=6d2bed1a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d2bed1a"]])

export default __exports__